import apiClient from "./client";
import type { UploadResponse } from "@/types/api";

export async function uploadFile(file: File): Promise<UploadResponse> {
  const formData = new FormData();
  formData.append("file", file);

  const res = await apiClient.post<UploadResponse>("/api/uploads", formData, {
    headers: { "Content-Type": "multipart/form-data" },
    timeout: 120_000,
  });
  return res.data;
}
